module.exports = __webpack_public_path__ + "img/special-icon1.bc133c34.png";